import styled from 'styled-components';

export const ButtonStyled = styled.button`
  height: 60px;
  min-width: 60px;
  border-radius: 4px;
  border: 1px solid #dcdce6;
  background: transparent;
  margin-left: 16px;
  transition: border-color 0.3s;
  :hover {
    border: 1px solid black;
  }
`;

